<template>
  <div>
    <v-tabs grow>
      <v-tab to="/admin/dashboard/charts">
        Charts
      </v-tab>
      <v-tab to="/admin/dashboard/stakeholderlist">
        Stakeholder List
      </v-tab>
      <v-tab to="/admin/dashboard/surveyresponses">
        Survey Responses
      </v-tab>
      <v-tab to="/admin/dashboard/map">
        Map
      </v-tab>
      <v-tab to="/admin/dashboard/calendar">
        Calendar
      </v-tab>
      <v-tab to="/admin/dashboard/exhibits">
        Exhibits
      </v-tab>
    </v-tabs>
    <router-view />
    <img
      src="/static/M-CORES/Dashboard.jpg"
      class="dashboard-logo-scout"
    >
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
  .v-content {
  padding: 50px 0 36px !important
}
.dashboard-logo-scout {
  margin-top: 1.5%;
  margin-bottom: 1.5%;
  margin-left: 35%;
  width: 30%;
}
</style>